import React, { useEffect, useState } from 'react';
import { sparkIcon } from '../../assets/images';
import heroImage from '../../assets/images/hero.png';

const HeroSection = ({ openContactModal }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  const handleExploreClick = (e) => {
    e.preventDefault();
    const coursesSection = document.getElementById('courses');
    if (coursesSection) {
      coursesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section" id="home">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-tag">
            START TO SUCCESS
            <img src={sparkIcon} alt="spark" className="spark-icon" />
          </div>
          <h1 className="hero-heading">
            <span className="line1">Launch Your Cloud Career,</span>
            <span className="line2">Learn AWS the Smart Way!</span>
          </h1>
          <p className="hero-description">
            Get trained by industry experts. Hands-on labs, resume 
            support, interview prep & live mentorship - all in one 
            powerful course.
          </p>
          <div className="hero-cta">
            <button className="explore-button" onClick={handleExploreClick} style={{ position: 'relative', zIndex: 5 }}>Explore Courses</button>
          </div>
        </div>
        {/* Decorative elements with responsive positioning */}
        <div style={{
            position: 'absolute',
            right: isMobile ? '10%' : '50px',
            top: isMobile ? '0' : '-60px',
            color: '#fca338',
            fontSize: isMobile ? '30px' : '40px',
            transform: 'rotate(90deg)',
            display: isMobile ? 'none' : 'block' // Hide on mobile
          }}>✧</div>
          <div style={{
            position: 'absolute',
            right: isMobile ? '15%' : '35%',
            fontSize: isMobile ? '50px' : '70px',
            bottom: isMobile ? '5%' : '-60px',
            color: '#2F74B2',
            transform: 'rotate(70deg)',
            display: isMobile ? 'none' : 'block' // Hide on mobile
          }}>✦</div>
          <div style={{
            position: 'absolute',
            right: '35.8%',
            fontSize: '25px',
            bottom: '0px',
            color: '#2F74B2',
            transform: 'rotate(60deg)',
            display: isMobile ? 'none' : 'block' // Hide on mobile
          }}>＋</div>
          <div style={{
            position: 'absolute',
            right: '35%',
            fontSize: '20px',
            bottom: '-5px',
            color: '#2F74B2',
            transform: 'rotate(60deg)',
            display: isMobile ? 'none' : 'block' // Hide on mobile
          }}>＋</div>
        <div className="hero-image-wrapper">
          <div className="hero-image-with-border" style={{ position: 'relative' }}>
            {/* Add border overlay div to create the visible part of the border */}
            <div style={{
              position: 'absolute',
              width: '102%',
              height: '102%',
              borderRadius: '200px 200px 200px 200px / 200px 200px 200px 200px',
              border: 'none',
              boxShadow: '0 0 0 2px #2F74B2',
              top: '-2.5%',
              right: '-6.5%',
              zIndex: '-1',
              clipPath: 'polygon(15% 0, 100% 0, 150% 50%, 0 50%)'
            }}></div>
            <div style={{
              position: 'absolute',
              width: '102%',
              height: '102%',
              borderRadius: '200px 200px 200px 200px / 200px 200px 200px 200px',
              border: 'none',
              boxShadow: '0 0 0 2px #2F74B2',
              top: '-2.5%',
              right: '-6.5%',
              zIndex: '-1',
              clipPath: 'polygon(0 60%, 100% 49%, 150% 100%, 50% 160%)'
            }}></div>
            {/* Hide the original border */}
            <div className="hero-outer-border" style={{ display: 'none' }}></div>
            <div className="hero-image-container">
              <img src={heroImage} alt="Student with Orange Notebook" className="hero-image" />
            </div>
            <div className="hero-image-top-overflow">
              <img src={heroImage} alt="" className="hero-image-top" />
            </div>
          </div>
        </div>
      </div>
      
      {/* Add decorative elements */}
      <div className="hero-decorations">
        <div className="green-dot"></div>
        <div className="purple-dot"></div>
        <div className="pink-dot"></div>
      </div>
    </section>
  );
};

export default HeroSection; 